module.exports = __webpack_public_path__ + "static/img/打折.e4782dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/user/center/打折.png
// module id = 40
// module chunks = 18